export const updateObject = <T = {}>(array: T[], idProperty: keyof T, newProperties: Partial<T>) => {
  return newProperties ? array.map((item) => {
    if ((item[idProperty] as unknown as string | number) === newProperties[idProperty] as unknown as string | number) {
      return {...item, ...newProperties};
    } else {
      return item;
    }
  }) : array;
};
